import script from "./LoyaltyFlag.vue?vue&type=script&setup=true&lang=js"
export * from "./LoyaltyFlag.vue?vue&type=script&setup=true&lang=js"

import "./LoyaltyFlag.vue?vue&type=style&index=0&id=32951cfa&lang=sass&scoped=true"

import exportComponent from "/home/goran/projects/plodine/plodine/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32951cfa"]])

export default __exports__